import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { CommonAction } from '../actions/CommonAction';
import { AuthAction } from '../actions/AuthAction';
import { Loading } from '../components/common/Loading';

const WidgetItemCountCard = ({ name, title, valuetitles = [], aggregate, action = null,
	dataType = "",
	subtitle, txtcolor = "default", bgcolor = "default", options, fontsize = "48", setting = false }) => {

	const [count, setCount] = useState([]);
	const [callCount, setCallCount] = useState(0);
	const [isFetch, setIsFetch] = useState(true);

	useEffect(() => {
		if (name) {
			let savedData = JSON.parse(localStorage.getItem(name));
			if (savedData) {
				if (new Date().getTime() - savedData.timestamp > 60 * 60 * 1000)
					savedData = null;
			}
			getData(savedData ? savedData.data : null);
		} else {
			getData(null);
		}
	}, [aggregate])

	useEffect(() => {
		const timer = setTimeout(() => getData(null), 60 * 60 * 1000);
		return () => clearTimeout(timer);
	}, [callCount])

	const setCountData = (data) => {
		if (data) {
			if (valuetitles.length > 0) {
				const nCount = []
				valuetitles.map(x => {
					if (data[0].hasOwnProperty(x)) {
						nCount.push(data[0][x].count.toLocaleString());
					} else {
						nCount.push("0");
					}
				})
				setCount(nCount.join("/", nCount));
			} else {
				if (dataType == "mstoday") {
					let t = data[0].count;
					if (t === 0) {
						setCount(0);
					} else {
						t = t / 1000 / 60 / 60 / 24;
						setCount(t.toFixed(0).toLocaleString());
					}
				} else {
					setCount(data[0]?.count.toLocaleString());
				}
			}
		} else {
			setCount(0);
		}
	}

	const getData = async (savedData) => {

		setIsFetch(true);

		// 조회·집계가 실패해도 로딩은 반드시 풀린다(finally).
		try {
			if (savedData) {
				setCountData(savedData);
			} else {
				const ret = await CommonAction.GetCountAction(aggregate);
				const sData = {
					timestamp: new Date().getTime(),
					data: ret?.data
				}

				if (name) {
					localStorage.setItem(name, JSON.stringify(sData));
				}

				setCountData(ret?.data);
			}
		} catch (e) {
			console.warn('[WidgetItemCountCard] getData failed', { name, title, reason: e?.message || String(e) });
			setCount(0);
		} finally {
			setIsFetch(false);
			setCallCount(callCount > 100 ? 0 : callCount + 1);
		}
	}

	return (
		<div className={isFetch ? "fadeLoading mb-2" : "mb-2"}>
			<div className={"card bg-" + bgcolor + " text-" + txtcolor}>
				<div className="card-header text-center separator">
					<div className='text-right'>
						{setting ? <a className='btn btn-sm mt-0' onClick={setting}><ion-icon name="settings-outline"></ion-icon></a> :
							<a className='btn btn-sm mt-0'></a>
						}
					</div>
					<div className="card-title">
						<h2 className="mb-0">{title}</h2>
						{subtitle && <span className="small mb-0">{subtitle}</span>}
						{!subtitle && <span className="small mb-0">&nbsp;</span>}
					</div>
				</div>
				<div className={"card-body text-" + txtcolor}>
					{isFetch
						? <div className="text-center" style={{ minHeight: (Number(fontsize) || 48) * 1.2 }}><Loading size={Math.round((Number(fontsize) || 48) * 0.8)} /></div>
						: <h1 className="text-center" style={{ fontSize: fontsize + "px" }}>{count ? count : 0}</h1>}
				</div>
			</div>
		</div>
	);
};

const mapState = (state) => {
	const user = state.AuthReducer.user;
	const deviceCategory = state.ProgramReducer.deviceCategory;
	const showmodel = state.ProgramReducer.showmodel;
	return { user, deviceCategory, showmodel };
}

const mapDisPatch = dispatch => ({
	UpdateUserAdminSetting: (userInfo) => dispatch(AuthAction.UpdateUserAdminSetting(userInfo)),
});

export default connect(mapState, mapDisPatch)(WidgetItemCountCard);
